/*
创建者 魏强(2018.1.25)
横栏广告
*/
<template>
	<div class="home-module">
            <h3 class="module-title">
            	<span>{{title}}</span>
            </h3>
            <div class="module-cont">
            	<left-ad :data="leftAdv.advList"></left-ad>
                <middle-ad 
                	:middleUpAdv="middleUpAdv"
                	:middleDownAdv="middleDownAdv">
            	</middle-ad>
                <right-ad :data="rightGoodsAdv.advList"></right-ad>
            </div>
        </div>
</template>
<script>
import leftAd  from './left-ad.vue';
import middleAd  from './middle-ad/index.vue';
import rightAd  from './right-ad.vue';
export default {
	props:[
	"title",
	"leftAdv",
	"middleDownAdv",
	"middleUpAdv",
	"rightGoodsAdv"
	],
	components:{
		leftAd,middleAd,rightAd
	},
	data(){
		return {
			value:0	
		}
	},
	created(){
	},
	methods:{

		
	}
}
</script>


// WEBPACK FOOTER //
// index.vue?078fb8c9